import { render, staticRenderFns } from "./preBillBase.vue?vue&type=template&id=3cb242ae&scoped=true&"
import script from "./preBillBase.vue?vue&type=script&lang=js&"
export * from "./preBillBase.vue?vue&type=script&lang=js&"
import style0 from "./preBillBase.vue?vue&type=style&index=0&id=3cb242ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb242ae",
  null
  
)

export default component.exports